import BankAccountService from '@/service/payment/serviceBankAccount'

const bankAccountService = new BankAccountService()
export default {
  namespaced: true,
  state: {
    payloadBankInfo: {
      type_account: '',
      document_number: '',
      name_account: '',
      bank_code: '',
      agencia: '',
      agencia_dv: '',
      conta: '',
      conta_dv: '',
    },
    refresh: false,
  },

  mutations: {
    setPayloadBank(state, payload) {
      state.payloadBankInfo = payload
    },

  },
  actions: {
    async createBankAccount({ state }, id) {
      try {
        const response = await bankAccountService.createBank(id, state.payloadBankInfo)
        state.refresh = !state.refresh
        return response
      } catch (error) {
        return error
      }
    },
    async deleteBankAccount({ state }, id) {
      try {
        const response = await bankAccountService.deleteBank(id)
        state.refresh = !state.refresh
        this.$store.commit('profileStore/CLEAR_BANK_ACCOUNT')
        return response
      } catch (error) {
        return error
      }
    },
    setPayloadBank({ commit }, payload) {
      commit('setPayloadBank', payload)
    },
    resetPayloadBank({ commit }) {
      commit('setPayloadBank', {
        type_account: '',
        document_number: '',
        name_account: '',
        bank_code: '',
        agencia: '',
        agencia_dv: '',
        conta: '',
        conta_dv: '',
      })
    },
  },
  getters: {
    getPayloadBank: state => state.payloadBankInfo,
    getRefresh: state => state.refresh,
  },
}
